var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { RECORD_TYPES_PREFIX, STATUS_ACTIVE, STATUS_INACTIVE, VISIBILITY_PRIVATE, VISIBILITY_SHARED } from './constants';
export var getVisibleColumnsKey = function (entityTypeId) { return "lists-visible-columns-".concat(entityTypeId); };
export var buildListsUrl = function (url, request) {
    var _a = request || {}, filters = _a.filters, offset = _a.offset, size = _a.size, idsToTrack = _a.idsToTrack, listsLastFetchedTimestamp = _a.listsLastFetchedTimestamp;
    var params = new URLSearchParams();
    var entityTypeIdsArray = [];
    if (filters === null || filters === void 0 ? void 0 : filters.length) {
        if (filters.includes(STATUS_ACTIVE) && !filters.includes(STATUS_INACTIVE)) {
            params.append('active', 'true');
        }
        else if (filters.includes(STATUS_INACTIVE) && !filters.includes(STATUS_ACTIVE)) {
            params.append('active', 'false');
        }
        if (filters.includes(VISIBILITY_PRIVATE) && !filters.includes(VISIBILITY_SHARED)) {
            params.append('private', 'true');
        }
        else if (filters.includes(VISIBILITY_SHARED) && !filters.includes(VISIBILITY_PRIVATE)) {
            params.append('private', 'false');
        }
        for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
            var filter = filters_1[_i];
            if (filter.startsWith(RECORD_TYPES_PREFIX)) {
                entityTypeIdsArray.push(filter.slice(RECORD_TYPES_PREFIX.length));
            }
        }
    }
    var entityTypeIdsString = entityTypeIdsArray.join(',');
    if (entityTypeIdsString)
        params.append('entityTypeIds', entityTypeIdsString);
    // If tracking IDs, don't use offset
    if (offset && !(idsToTrack === null || idsToTrack === void 0 ? void 0 : idsToTrack.length))
        params.append('offset', offset.toString());
    if (size)
        params.append('size', size.toString());
    if (idsToTrack === null || idsToTrack === void 0 ? void 0 : idsToTrack.length) {
        params.append('ids', idsToTrack.join(','));
    }
    if (listsLastFetchedTimestamp)
        params.append('updatedAsOf', listsLastFetchedTimestamp);
    var paramString = params.toString();
    if (paramString) {
        return url + "?".concat(paramString);
    }
    return url;
};
export var createColumnHash = function (listColumns) {
    var sortedColumns = __spreadArray([], listColumns, true).sort(function (a, b) {
        return a.localeCompare(b, 'en', { sensitivity: 'base' });
    });
    return "".concat(sortedColumns.join());
};
export var createStorageHashKey = function (listID) { return "".concat(listID, "-hash"); };
export var checkIncludes = function (target, string) {
    return string.includes(target);
};
export var filterByIncludes = function (term, options) {
    return options.filter(function (option) {
        return checkIncludes(term.toLowerCase(), option.label.toLowerCase());
    });
};
export var getStatusButtonElem = function () {
    var _a;
    return (_a = document.getElementById('mainFiltersWrapper')) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('button')[0];
};
export var handleKeyCommand = function (callback, condition, onFalseConditions) {
    if (condition === void 0) { condition = true; }
    if (onFalseConditions === void 0) { onFalseConditions = function () { }; }
    return function (event) {
        event.preventDefault();
        if (condition) {
            callback();
        }
        else {
            onFalseConditions();
        }
    };
};
export var removeBackslashes = function (str) {
    if (str === void 0) { str = ''; }
    return str.replace(/\\(.)/g, '$1');
};
